angular.module('nv.components.sorter-col-input-details', ['nv.components.sorter-col-input']);
